export const TRANSLATED_TEXT_LOCALES = ['fr', 'en', 'de', 'it', 'es', 'pt', 'pl', 'nl', 'sv'] as const;
